import React, { useMemo } from 'react';
import {
  Descriptions,
  Col,
  Row,
} from 'antd';
import PropTypes from 'prop-types';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { normalizeObject, PREDIOS_MAPPING } from '../utils/mapping';
import ModalJSON from './ModalJSON';
import ModalObservaciones from './ModalObservaciones';

const MAP = {
  [padronesEnum.PREDIO]: PREDIOS_MAPPING,
};

const PadronDescription = ({
  padron,
  tipoDePadron,
  setObservaciones,
}) => {
  const mapperPadron = MAP?.[tipoDePadron];

  if (!mapperPadron) {
    return <div>Padrón no soportado</div>;
  }

  const normalizedPadron = useMemo(() => normalizeObject(padron, mapperPadron), [
    padron,
    mapperPadron,
  ]);

  return (
    <Row justify="end">
      {padron?.id && (
        <>
          <Col>
            <ModalJSON json={padron} label="padrón" />
          </Col>
          <Col>
            <ModalObservaciones
              setter={setObservaciones}
              formItemName="observaciones_del_padron"
              label="Agregar observaciones al padrón"
            />
          </Col>
        </>
      )}
      <Col span={24}>
        <Descriptions
          layout="vertical"
          size="small"
          bordered
          column={{
            xs: 1, sm: 2, md: 3, lg: 4,
          }}
          labelStyle={{ fontWeight: 'bold' }}
        >
          <Descriptions.Item label="Clave del padrón">
            {normalizedPadron.clave_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Clave principal del padrón">
            {normalizedPadron.clave_principal_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Clave secundaria del padrón">
            {normalizedPadron.clave_secundaria_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Estatus del padrón">
            {normalizedPadron.estatus_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Nombres completos del padrón" span={4}>
            {normalizedPadron.nombres_completos_del_padron || ' - '}
          </Descriptions.Item>
          {/* <Descriptions.Item label="Código postal del padrón" span={1}>
            {normalizedPadron.direccion_codigo_postal || ' - '}
          </Descriptions.Item> */}
          <Descriptions.Item label="Teléfono del padrón" span={2}>
            {normalizedPadron.telefono_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Correo electrónico del padrón" span={2}>
            {normalizedPadron.correo_electronico_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección del padrón" span={2}>
            {normalizedPadron.direccion_del_padron?.toUpperCase() || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección de notificación del padrón" span={2}>
            {normalizedPadron.direccion_de_notificacion_del_padron?.toUpperCase() || ' - '}
          </Descriptions.Item>
          {normalizedPadron?.observaciones_del_padron && (
            <Descriptions.Item label="Observaciones" span={4}>
              {normalizedPadron.observaciones_del_padron || ' - '}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Col>
    </Row>
  );
};

export default PadronDescription;

PadronDescription.propTypes = {
  padron: PropTypes.shape({
    id: PropTypes.number,
  }),
  tipoDePadron: PropTypes.string.isRequired,
  setObservaciones: PropTypes.func.isRequired,
};

PadronDescription.defaultProps = {
  padron: null,
};
